function m(t = 0) {
  if (t > 1e3) {
    const e = t / 1e3;
    return Number.isInteger(e) ? `${e} km` : `${e.toFixed(2)} km`;
  }
  return Number.isInteger(t) ? `${t} m` : `${t.toFixed(2)} m`;
}
export {
  m as default
};
